import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const handleNavigateToFeatures = () => {
    window.REACT_APP_NAVIGATE('/features');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  const handleNavigateToAbout = () => {
    window.REACT_APP_NAVIGATE('/about');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        
        {/* Features & About Links Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8">
              <button
                onClick={handleNavigateToFeatures}
                className="group block bg-gray-50 p-10 hover:bg-gray-100 transition-all duration-300 cursor-pointer text-left"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary group-hover:bg-accent transition-colors">
                    <i className="ri-star-line text-2xl text-white"></i>
                  </div>
                  <i className="ri-arrow-right-line text-2xl text-primary group-hover:translate-x-2 transition-transform"></i>
                </div>
                <h3 className="text-2xl font-bold text-primary mb-3">Nowestの特徴</h3>
                <p className="text-secondary leading-relaxed">
                  科学的根拠に基づく記憶術、個別最適化されたプログラム、経験豊富な講師陣など、私たちの強みをご紹介します。
                </p>
              </button>

              <button
                onClick={handleNavigateToAbout}
                className="group block bg-gray-50 p-10 hover:bg-gray-100 transition-all duration-300 cursor-pointer text-left"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary group-hover:bg-accent transition-colors">
                    <i className="ri-building-2-line text-2xl text-white"></i>
                  </div>
                  <i className="ri-arrow-right-line text-2xl text-primary group-hover:translate-x-2 transition-transform"></i>
                </div>
                <h3 className="text-2xl font-bold text-primary mb-3">会社概要</h3>
                <p className="text-secondary leading-relaxed">
                  「覚えられない」を無くす。株式会社Nowestのビジョン、会社情報、実績をご紹介します。
                </p>
              </button>
            </div>
          </div>
        </section>

        <Contact />
      </main>
      <Footer />
    </div>
  );
}
